import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {faTimes} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-v-sensor-location-param',
    templateUrl: './v-sensor-location-param.component.html',
    styleUrls: ['./v-sensor-location-param.component.css']
})
export class VSensorLocationParamComponent {

    @Input() paramGroup: FormGroup;
    @Input() readOnly = false;
    @Output() deleteLocation = new EventEmitter();
    @ViewChild('location1Input') location1Input: ElementRef;
    faTimes = faTimes;

    constructor() {
    }

}
